import React from "react";
import DPHeadCellWithTooltip from "Components/DP/DPHeadCell/DPHeadCell";
import { Typography } from "@material-ui/core";

export const MeanHeadCell = () => {
  return (
    <DPHeadCellWithTooltip
      label="Mean"
      content={
        <Typography variant="body1">
          Average net earnings amount.
        </Typography>
      }
    />
  );
};
